module.exports = __webpack_public_path__ + "img/1492837660.27309af5.jpg";